export function yieldToMain(timeoutMs = 32): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      (
        window as Window & {
          requestIdleCallback: (
            callback: () => void,
            options?: { timeout: number },
          ) => number;
        }
      ).requestIdleCallback(() => resolve(), { timeout: timeoutMs });
      return;
    }
    window.setTimeout(resolve, 0);
  });
}

export function scheduleIdleTask(callback: () => void): () => void {
  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    const idleWindow = window as Window & {
      requestIdleCallback: (
        cb: () => void,
        options?: { timeout: number },
      ) => number;
      cancelIdleCallback: (handle: number) => void;
    };
    const handle = idleWindow.requestIdleCallback(callback, { timeout: 120 });
    return () => idleWindow.cancelIdleCallback(handle);
  }

  const timeoutId = window.setTimeout(callback, 0);
  return () => window.clearTimeout(timeoutId);
}
